// extracted by mini-css-extract-plugin
export default {"locationInput":"styles_locationInput__PgHPM"};